'use client';

import React, { createContext, useContext } from 'react';

import { useWebSocketConnection } from '@/hooks/useWebSocketConnection';
import { SocketContextType } from '@/types/socket.types';

import {
  API_ENDPOINTS,
  POLYMARKET_SPORTS_WS_URL,
  POLYMARKET_WS_URL,
} from '@/constants/api.constants';

const SocketContext = createContext<SocketContextType>({
  crypto: { socket: null, isConnected: false },
  sports: { socket: null, isConnected: false },
});

export const useSocketContext = () => useContext(SocketContext);

import { usePathname } from 'next/navigation';

export const SocketProvider = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname() || '';

  // Connect sports socket only if on a sports page. Connect crypto on crypto pages.
  const isSportsPage = pathname.includes('/sports');
  const isCryptoPage =
    pathname.includes('/crypto') || pathname.includes('/live-markets') || pathname === '/';

  const crypto = useWebSocketConnection(
    POLYMARKET_WS_URL,
    API_ENDPOINTS.MARKET_WS_ENDPOINT,
    isCryptoPage || isSportsPage,
  );
  const sports = useWebSocketConnection(
    POLYMARKET_SPORTS_WS_URL,
    API_ENDPOINTS.SPORTS_WS_ENDPOINT,
    isSportsPage,
  );

  const value = {
    crypto,
    sports,
  };

  return <SocketContext.Provider value={value}>{children}</SocketContext.Provider>;
};
